import { render, staticRenderFns } from "./RecursiveBlock.vue?vue&type=template&id=b4036ce2&scoped=true&"
import script from "./RecursiveBlock.vue?vue&type=script&lang=js&"
export * from "./RecursiveBlock.vue?vue&type=script&lang=js&"
import style0 from "./RecursiveBlock.vue?vue&type=style&index=0&id=b4036ce2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4036ce2",
  null
  
)

export default component.exports